module.exports = $;